import { render, staticRenderFns } from "./ProductsMarkets.vue?vue&type=template&id=33d96ade&scoped=true&"
import script from "./ProductsMarkets.vue?vue&type=script&lang=ts&"
export * from "./ProductsMarkets.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsMarkets.vue?vue&type=style&index=0&id=33d96ade&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d96ade",
  null
  
)

export default component.exports